import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueI18n from "vue-i18n";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import echarts from "echarts";


Vue.use(ElementUI);
Vue.use(VueI18n);

let i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "en",
  messages: {
    en: require("../utils/en.js").lang,
    cn: require("../utils/cn.js").lang,
    // 	'en': require('./locales/zh-en.js').lang,
  },
});

Vue.config.productionTip = false;
Vue.prototype.$echarts = echarts;

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
